import React, { useEffect } from "react";
import { openModal } from "../../../business/redux/reducers/modal/actions";
import { useDispatch, useSelector } from "react-redux";
import { Badge, Box, Button, Container, Grid, Typography } from "@mui/material";
import { FilterAltOutlined } from "@mui/icons-material";
import { HeaderIconsSection } from "../headerIconsSection";
import { getProposalList } from "../../../business/redux/reducers/proposalReducer/actions";
import { ProposalListFilterContent } from "../../modal/informationModal/contents";

export const HeaderMiddleSectionFromProposalList = () => {
  const { proposalListFilterParams } = useSelector((s) => s.filters);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getProposalList({ filterFormData: proposalListFilterParams })
    ).then((r) => r);
  }, []);

  const badgeContent = Object.keys(proposalListFilterParams).reduce(
    (acc, curr) => {
      return Array.isArray(proposalListFilterParams[curr])
        ? acc + Number(!!proposalListFilterParams[curr].length)
        : acc + Number(!!proposalListFilterParams[curr]);
    },
    0
  );

  return (
    <>
      <Container
        className="statistic_filter_container"
        maxWidth="false"
        style={{ backgroundColor: "#fff", padding: "5px 8px" }}
      >
        <Grid container direction="row" alignItems="center">
          <Grid
            item
            container
            direction="row"
            xs={2}
            sx={{ py: 0, px: 1 }}
            alignItems="center"
          >
            <HeaderIconsSection />
          </Grid>
          <Grid
            item
            container
            direction="row"
            xs={10}
            sx={{ py: 0, px: 1 }}
            alignItems="center"
            justifyContent="flex-end"
          >
            <Box display={"flex"} sx={{ p: 1, ml: 3 }}>
              <Button
                sx={{ mr: 0 }}
                className="Campaign_btn"
                onClick={() =>
                  dispatch(
                    openModal({
                      content: <ProposalListFilterContent />,
                      style: { width: "780px" },
                    })
                  )
                }
              >
                <Badge
                  badgeContent={badgeContent}
                  color="primary"
                  sx={{ mr: 2 }}
                  className="filter_count"
                >
                  <FilterAltOutlined sx={{ fontSize: "24px" }} />
                </Badge>{" "}
                filters
              </Button>
              <Typography
                variant="div"
                component="span"
                className="count_campaign_step count_campaign_step_right"
              >
                {badgeContent}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
